<template>
  <div class="flex flex-col" :class="size">
    <slot name="label">
      <label :for="props.name" :class="props.labelClasses">{{ label }}</label>
    </slot>
    <slot :value="value" :errorMessage="errorMessage">
      <DatePicker
        manualInput
        showIcon
        :show-button-bar
        icon-display="button"
        inputId="modelField"
        class="h-10"
        :inputClass="props.inputClass"
        panelClass="bg-white dark:bg-surface-700/80 backdrop-blur-xl"
        :maxDate="props.maxDate"
        v-model="value"
        :show-on-focus="false"
        :disabled="disabled"
        @date-select="onSelect()"
      />
      <small v-if="errorMessage" :id="props.name + '-help'" class="text-danger-500">{{ errorMessage }}</small>
    </slot>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate";

interface Props {
  name: string;
  label: string;
  value?: Date;
  maxDate?: Date;
  labelClasses?: string;
  disabled?: boolean;
  onSelect?: Function;
  size?: string;
  showButtonBar?: boolean;
  inputClass?: string;
}
const props = withDefaults(defineProps<Props>(), {
  value: () => new Date(),
  maxDate: () => new Date(),
  labelClasses: "font-bold",
  disabled: false,
  size: "w-full",
  showButtonBar: true,
  inputClass: "w-36",
});

const { value, errorMessage } = useField<string>(() => props.name);

const onSelect = (): void => {
  if (props.onSelect != null) props.onSelect();
};
</script>
